import spinner from '../assets/spinner.gif'

const Spinner =()=>{
 return (
    <>
       <img src={spinner} alt="Not fount!"
        className='d-block m-auto'
        style={{width:"100px"}}
      />
    </>
 )
}

export default Spinner;